module.exports = __webpack_public_path__ + "fonts/karla700.f4f638d0.woff";